import { render, staticRenderFns } from "./Branding.vue?vue&type=template&id=e85efe74&"
import script from "./Branding.vue?vue&type=script&lang=js&"
export * from "./Branding.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports